module.exports = __webpack_public_path__ + "static/media/hippo.664b00f5.svg";